/**
 * @file 自动保存
 * @author sunyingying01
 */

import React from 'react';
import styles from './index.module.less';

interface AutoSaveProps {
  /** 是否正在保存中 */
  saving?: boolean;
  /** 最后保存时间 */
  lastSavedTime?: string;
}

const AutoSave: React.FC<AutoSaveProps> = ({saving, lastSavedTime}) => (
    <div className={styles.autoSave}>
      {saving ? (
        <>
          <span className={styles.autoSaveText}>保存中...</span>
        </>
      ) : (
        <>
          {lastSavedTime && (
              <span className={styles.autoSaveText}>
                自动保存于 {lastSavedTime}
              </span>
          )}
        </>
      )}
    </div>
);

export default AutoSave;
